import { MsdDto } from "src/app/services/generatedApi";

export const defaultMsdData: MsdDto = {
  lowBack: {
    posture: {
      backBent30_2hours: false,
      backBent30_4hours: false,
      backBent45_1hour: false,
      backBent45_2hours: false,
    },
    force: {
      lift75lb_once: false,
      lift55lb_10times: false,
      lift55lb_20times: false,
      liftAwkward25lb_10pounds: false,
      liftAwkward25lb_20pounds: false,
      liftRepeat10lb_2hours: false,
      liftRepeat10lb_4hours: false,
    },
  },
  handWrist: {
    pinch: {
      pinch2lb_2hours: false,
      pinch2lb_4hours: false,
      pinchDeviation_3hours: false,
      pinchRepetitive_3hours: false,
    },
    grip: {
      grip10lb_2hours: false,
      grip10lb_4hours: false,
      gripDeviation_3hours: false,
      gripRepetitive_3hours: false,
    },
    motion: {
      handWristRepetitiveMotion_2hours: false,
      handWristRepetitiveMotion_6hours: false,
      repetitiveWithForce_2hours: false,
      keying_4hours: false,
      keying_7hours: false,
      keyingDeviation_4hours: false,
    },
    impact: {
      handHammer_10perHour: false,
      handHammer_1perMinute: false,
    },
    vibration: {
      moderateVibration_2hours: false,
      moderateVibration_4hours: false,
      highVibration_30min: false,
      highVibration_1hour: false,
    },
  },
  neckShoulder: {
    neckPosture: {
      neckBent30_2hours: false,
      neckBent45_2hours: false,
      neckBent45_4hours: false,
    },
    shoulderPosture: {
      handsAboveHead_2hours: false,
      handsAboveHead_4hours: false,
      raisingHandsAboveHead_2hours: false,
      raisingHandsAboveHead_4hours: false,
    },
    motion: {
      neckShoulderRepetitiveMotion_2hours: false,
      neckShoulderRepetitiveMotion_6hours: false,
    },
  },
  knee: {
    posture: {
      squatting_2hours: false,
      squatting_4hours: false,
      kneeling_2hours: false,
      kneeling_4hours: false,
    },
    impact: {
      kneeHammer_10perHour: false,
      kneeHammer_1perMinute: false,
    },
  },
  handArmVibration: undefined,
  liftingAnalysis: undefined,
};

export enum MsdRiskLevel {
  LOW = "Low",
  MODERATE = "Moderate",
  HIGH = "High",
  VERY_HIGH = "Very High",
}

export const CAUTION_ZONE_THRESHOLD = 1;
export const HAZARD_ZONE_THRESHOLD = 1;

export const riskFactorPaths = {
  lowBack: {
    cautionZone: [
      { path: "posture.backBent30_2hours" },
      { path: "posture.backBent45_1hour" },
      { path: "force.lift55lb_10times" },
      { path: "force.liftAwkward25lb_10pounds" },
      { path: "force.liftRepeat10lb_2hours" },
    ],
    hazardZone: [
      { path: "posture.backBent30_4hours" },
      { path: "posture.backBent45_2hours" },
      { path: "force.lift75lb_once" },
      { path: "force.lift55lb_20times" },
      { path: "force.liftAwkward25lb_20pounds" },
      { path: "force.liftRepeat10lb_4hours" },
    ],
  },
  handWrist: {
    cautionZone: [
      { path: "pinch.pinch2lb_2hours" },
      { path: "grip.grip10lb_2hours" },
      { path: "motion.handWristRepetitiveMotion_2hours" },
      { path: "motion.keying_4hours" },
      { path: "impact.handHammer_10perHour" },
      { path: "vibration.moderateVibration_2hours" },
      { path: "vibration.highVibration_30min" },
    ],
    hazardZone: [
      { path: "pinch.pinch2lb_4hours" },
      { path: "pinch.pinchDeviation_3hours" },
      { path: "pinch.pinchRepetitive_3hours" },
      { path: "grip.grip10lb_4hours" },
      { path: "grip.gripDeviation_3hours" },
      { path: "grip.gripRepetitive_3hours" },
      { path: "motion.handWristRepetitiveMotion_6hours" },
      { path: "motion.repetitiveWithForce_2hours" },
      { path: "motion.keying_7hours" },
      { path: "motion.keyingDeviation_4hours" },
      { path: "impact.handHammer_1perMinute" },
      { path: "vibration.moderateVibration_4hours" },
      { path: "vibration.highVibration_1hour" },
    ],
  },
  neckShoulder: {
    cautionZone: [
      { path: "neckPosture.neckBent30_2hours" },
      { path: "neckPosture.neckBent45_2hours" },
      { path: "shoulderPosture.handsAboveHead_2hours" },
      { path: "shoulderPosture.raisingHandsAboveHead_2hours" },
      { path: "motion.neckShoulderRepetitiveMotion_2hours" },
    ],
    hazardZone: [
      { path: "neckPosture.neckBent45_4hours" },
      { path: "shoulderPosture.handsAboveHead_4hours" },
      { path: "shoulderPosture.raisingHandsAboveHead_4hours" },
      { path: "motion.neckShoulderRepetitiveMotion_6hours" },
    ],
  },
  knee: {
    cautionZone: [
      { path: "posture.squatting_2hours" },
      { path: "posture.kneeling_2hours" },
      { path: "impact.kneeHammer_10perHour" },
    ],
    hazardZone: [
      { path: "posture.squatting_4hours" },
      { path: "posture.kneeling_4hours" },
      { path: "impact.kneeHammer_1perMinute" },
    ],
  },
};
